import api from "./api";
import queryString from "query-string";

export default {
  adminPreviewOnSite(apiKey, godMode) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `watch/admin_preview_on_site`,
          json: godMode ? { god_mode: true } : undefined,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/WatchUtil.js